import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { useContentObjectType } from 'content-management-data-lib';
import { useContentActions } from 'content-management-actions-lib/providers/ContentActionsProvider';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NoPreviewUrl = ({
  crmObject
}) => {
  const {
    contentObjectTypeSingularNoun
  } = useContentObjectType();
  const {
    allActions
  } = useContentActions();
  return /*#__PURE__*/_jsxs(Text, {
    as: "small",
    typography: "detail-200",
    textAlign: "center",
    color: "text-tertiary-default",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "content-management-listing-lib.table.cells.urlLabel.noUrl"
    }), /*#__PURE__*/_jsx(HelpIcon, {
      title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "content-management-listing-lib.table.cells.urlLabel.tooltip_jsx",
        options: {
          onClick: () => {
            if (allActions.edit && allActions.edit.onActionButtonClick) {
              allActions.edit.onActionButtonClick(crmObject);
            }
          },
          contentObjectTypeSingularNoun
        },
        elements: {
          UILink: Link
        }
      }),
      tooltipPlacement: "bottom",
      alignWithText: true,
      marginInlineStart: "200"
    })]
  });
};
export default NoPreviewUrl;